// @ts-check

import { Box } from '@mui/material';

/**
 * @typedef {React.FC} AspectRatioBox
 * @param {{children: JSX.Element, ratio?: number }} arg0
 * @returns {JSX.Element}
 */
export default function AspectRatioBox({ children, ratio = 1 }) {
    return (
        <Box sx={{ position: 'relative', width: 1, height: 1 }}>
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    '& > *': { width: '100%', height: '100%', objectFit: 'cover' }
                }}
            >
                {children}
            </Box>
            <Box sx={{ pb: (1 / ratio) * 100 + '%' }} />
        </Box>
    );
}
